const getListSelected = (params: any, type: string) => {
  let selectList: any = {list: [], type};
  
  let selectNodes = params.api.getSelectedNodes()
  
  if (selectNodes.length && selectNodes.map((i: any)=>i.glid).includes(params.node.data.glid)) {
    selectList = {
      ...selectList,
      list: selectNodes.map((i: any) => i.data)
    }
  } else {
    selectList = {
      ...selectList,
      list: [params.node.data]
    }
  }
  
  return selectList;
}

export default getListSelected;